// Shared prop shapes for the API objects the Shared Setting form renders.

import PropTypes from 'prop-types';

export const attributeShape = PropTypes.shape({
  name: PropTypes.string.isRequired,
  html_tag: PropTypes.string,
});

export const integrationShape = PropTypes.shape({
  id: PropTypes.string.isRequired,
  attributes: PropTypes.shape({
    name: PropTypes.string,
    location_settings_schema: PropTypes.arrayOf(attributeShape),
  }).isRequired,
});

export const mappingShape = PropTypes.shape({
  from_integration_uuid: PropTypes.string,
  from_attribute_name: PropTypes.string,
  to_integration_uuid: PropTypes.string,
  to_attribute_name: PropTypes.string,
  rowIdx: PropTypes.number,
});

export const optionShape = PropTypes.shape({
  id: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
});

// Attribute name -> its schema entry, for one side of a pair.
export const schemaMapShape = PropTypes.objectOf(attributeShape);

// `${integrationId}.${attributeName}` -> the header keys seen in use.
export const headerKeysShape = PropTypes.objectOf(
  PropTypes.arrayOf(PropTypes.string),
);
